module.exports = __webpack_public_path__ + "c7b749802fa088c38150576c119a8978.png";